import type { Cell, CellState } from '../demo/seed';

export function tierFor(balance: number, computeCost: number): CellState {
  if (balance <= 0) return 'dead';
  const r = balance / Math.max(computeCost, 1e-9);
  if (r > 24) return 'thriving';
  if (r > 6) return 'alive';
  if (r > 2) return 'low';
  return 'critical';
}

export function colorForTier(state: CellState): string {
  switch (state) {
    case 'thriving':
      return '#00FF88';
    case 'alive':
      return '#1E6FFF';
    case 'low':
      return '#FFB800';
    case 'critical':
      return '#FF3344';
    case 'dead':
      return '#2A2A2A';
    case 'empty':
    default:
      return '#0A0A0A';
  }
}

export function labelForTier(state: CellState): string {
  switch (state) {
    case 'thriving':
      return 'THRIVING';
    case 'alive':
      return 'NORMAL';
    case 'low':
      return 'LOW COMPUTE';
    case 'critical':
      return 'CRITICAL';
    case 'dead':
      return 'DEAD';
    case 'empty':
    default:
      return 'EMPTY';
  }
}

export function cellIsAlive(cell: Cell): boolean {
  return cell.state === 'alive' || cell.state === 'thriving' || cell.state === 'low' || cell.state === 'critical';
}
